function fn_comp_maxinfo() {
    var $fn = $(".comp_maxinfo");

    if($fn.length){
        $fn.find(".part_form").each(function (index) {
            var $this = $(this);
            var $points = [[0, 7.35], [100, 0], [97, 100], [2.5, 100], [0, 7.35]];

            $this.clipPath($points, {
                isPercentage: true,
                svgDefId: "maxinfoclip"+index
            })
        })
    }
}